/**
 * PATH: packages/email-hub/src/feature/email-layout/EmailHubPausedState.tsx
 * FILE_ID: EMAIL-LAYOUT-PAUSED-STATE-001
 * PURPOSE: Render the existing Quotech-auth-loss fallback.
 */

import { LinkIcon } from 'lucide-react'

export function EmailHubPausedState() {
  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="max-w-md w-full rounded-2xl border border-border bg-card p-6 shadow-sm">
        <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-amber-500/10 text-amber-600 dark:text-amber-300">
          <LinkIcon className="h-5 w-5" />
        </div>
        <h1 className="text-lg font-semibold text-foreground">
          Email Hub paused - Quotech connection lost
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          The Email Hub talks to the master Quotech backend (different from
          your SAM session). Its session cookie has expired or been cleared,
          so emails, sync status, and Outlook/Gmail integrations are
          temporarily unreachable.
        </p>
        <p className="mt-3 text-sm text-muted-foreground">
          Click <span className="font-medium text-foreground">Reconnect Quotech</span>{' '}
          in the amber banner at the top of the page to restore the session.
          You'll bounce through Quotech sign-in and come back to this screen
          automatically.
        </p>
      </div>
    </div>
  )
}
